import { connectCustom } from "@client/lib/misc";

import { globals } from "@client/globals";
import { type AppState } from "@client/types";
import Component, { type LoginProps } from "./component";

const mapStateToProps = (state: AppState): LoginProps => {
  return {
    url: globals.siteInfo.adminLoginUrl
  };
};

export default connectCustom(mapStateToProps)(Component);
